import { render, staticRenderFns } from "./vliveExampleWechatShare.vue?vue&type=template&id=8dd236c8&"
import script from "./vliveExampleWechatShare.vue?vue&type=script&lang=js&"
export * from "./vliveExampleWechatShare.vue?vue&type=script&lang=js&"
import style0 from "./vliveExampleWechatShare.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports